export interface ConnectionType {
  id: string;
  key: string;
  description: string;
}
